import './InlineMetadata.scss';

import { DetailSubsection } from '../DetailSubsection';
import React from 'react';

export interface InlineMetadataProps {
	children: React.ReactNode;
	headerSpaceAlign?: 'center' | 'start' | 'end' | 'baseline';
	label: string;
}

export const InlineMetadata: React.FC<InlineMetadataProps> = ({ children, headerSpaceAlign, label }) =>
	<DetailSubsection
		className='inline-metadata'
		headerSpaceAlign={ headerSpaceAlign }
		title={ label }
		titleExtra={ children } />;

